import { HStack } from "@chakra-ui/layout";
import { Link } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { useInvoiceDetailStore } from "../../../store";
import { Item } from "../../common";

export const PaymentReceipt = () => {
  const store = useInvoiceDetailStore();

  return (
    <div className="mb-6">
      <Item label={t`Payment receipt`}>
        {store.invoice?.proofOfPayments && (
          <HStack>
            {store.invoice.proofOfPayments.map((proof) => (
              <Link
                key={`invoice-proof-${proof.id}`}
                href={{
                  pathname: "/invoices/outgoing-invoices/detail",
                  query: { id: proof.id },
                }}
              >
                {`#${proof.invoice_no}`}
              </Link>
            ))}
          </HStack>
        )}
      </Item>
    </div>
  );
};
